const actions = {
  login: 'LOGIN_USER',
  logout: 'LOGOUT',
  resetUserState: 'RESET_USER_STATE',
  getUserFromToken: 'GET_USER_FROM_TOKEN',
  createUser: 'CREATE_USER',
  updateUser: 'UPDATE_USER',
  listUser: 'LIST_USER',
  getUser: 'GET_USER',
  keepAlive: 'KEEP_ALIVE',
  loginOfflineUser: 'LOGIN_OFFLINE_USER',
};

export default actions;
